<template>
	<div id="appraisals-index"
		 class="app-home ui-styles"
		 :class="theme">
		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen"
							  :reportOpen="reportOpen"
				></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1><span v-if="!appraiser.surnames">{{ $t('New_appraiser') }}</span><span
							v-else>{{ $t('Appraiser') }} {{ appraiser.name }} {{ appraiser.surnames
						}}</span> <span v-if="appraiser.dirty">*</span></h1>
					<message
							v-if="appraiser.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(appraiser.date_created) }}</p>
						<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(appraiser.date_modified) }}</p>
					</div>
					<div>
						<form class="bt-form">

							<div class="form-section">
								<h3>{{ $t('Data') }}</h3>
								<div class="field-container">
									<div class="field__group">
										<label class="field__group__label">{{ $t('Name') }}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="appraiser.name"
											   @input="set_appraiser_name">
									</div>

									<div class="field__group">
										<label class="field__group__label">{{ $t('Surnames') }}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="appraiser.surnames"
											   @input="set_appraiser_surnames">
									</div>
								</div>
								<div class="field-container">
									<div class="field__group">
										<label class="field__group__label">{{ $t('TIN') }}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="appraiser.tin"
											   @input="set_appraiser_tin">
									</div>
									<div class="field__group">
										<label class="field__group__label">{{ $t('Prof_assoc_reg_number') }}</label>
										<input class="field__group__input"
											   type="text"
											   spellcheck="false"
											   v-model="appraiser.prof_assoc_reg_number"
											   @input="set_appraiser_prof_assoc_reg_number">
									</div>
								</div>
							</div>

							<div>
								<hr>
							</div>
							<div>
								<div @click.prevent="onGoBack" style="width: fit-content; margin-left: auto">
									<icon-button icon="chevron-left" :text="goback_button_text"
												 icon_color="black"
												 text_color="black" border_color="lightgray"></icon-button>
								</div>
							</div>
							<div>
								<div @click.prevent="onSaveCurrentAppraiser({goback: true})"
									 style="width: fit-content; margin-left: auto">
									<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
												 text_color="white" border_color="#006bc5"
												 background_color="#0087F8"></icon-button>
								</div>
							</div>
							<message
									v-if="appraiser.dirty"
									:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
									border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
							</message>
						</form>
					</div>

<!--
					<bar>
					</bar>
					-->

				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import router from '../../../router'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import Message from '../../../components/Message.vue'
    import SuccessMessage from '../../../components/SuccessMessage.vue'

    import honorificTitleOptions from '../../../options/honorific_titles'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'appraiser-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            master_loading: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            new_address_button_text: Vue.i18n.translate('Add_address'),
            new_email_button_text: Vue.i18n.translate('Add_email'),
            new_telephone_button_text: Vue.i18n.translate('Add_telephone_number'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_back'),
            cad_ref_error_text_01: Vue.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            value: null,
            ms_placeholder: Vue.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions,
        }),

        created () {

        },

        components: {
            Bar,
            Message,
            SuccessMessage,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'currentLocale',
                'address',
                'emailaddress',
                'telephonenumber',
                'appraiser',
                'appraiser_addresses',
                'appraiser_emailaddresses',
                'appraiser_telephonenumbers'
            ])
        },

        created () {

            this.master_loading = false

        },

        methods: {
            ...mapActions(
                [
                    'SET_APPRAISER_ADDRESSES',
                    'SET_APPRAISER_NAME',
                    'SET_APPRAISER_SURNAMES',
                    'SET_APPRAISER_TIN',
                    'SET_APPRAISER_PROF_ASSOC_REG_NUMBER',
                    'SET_APPRAISER_TITLE',
                    'SET_APPRAISER_COMPLETE_NAME',
                    'UPDATE_APPRAISER'
                ]),
            set_appraiser_name: _.debounce(function (e) {
                let name = e.target.value
                let surnames = ''
                if (this.appraiser.surnames) {
                    surnames = this.appraiser.surnames
                }
                let complete_name = surnames + ', ' + name
                this.SET_APPRAISER_NAME(name)
                this.SET_APPRAISER_COMPLETE_NAME(complete_name)
            }, 1000),
            set_appraiser_surnames: _.debounce(function (e) {
                let surnames = e.target.value
                let name = ''
                if (this.appraiser.name) {
                    name = this.appraiser.name
                }
                let complete_name = surnames + ', ' + name
                this.SET_APPRAISER_SURNAMES(surnames)
                this.SET_APPRAISER_COMPLETE_NAME(complete_name)
            }, 1000),
            set_appraiser_tin: _.debounce(function (e) {
                this.SET_APPRAISER_TIN(e.target.value)
            }, 1000),
            set_appraiser_prof_assoc_reg_number: _.debounce(function (e) {
                this.SET_APPRAISER_PROF_ASSOC_REG_NUMBER(e.target.value)
            }, 1000),
            set_appraiser_title: _.debounce(function (e) {
                this.SET_APPRAISER_TITLE(e)
            }, 1000),
            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            },
            onSaveCurrentAppraiser: function (data) {
                console.log('appraiser.id: ')
                console.log(this.appraiser.id)
                this.UPDATE_APPRAISER({
                    object: this.appraiser,
                    path: 'appraisers' + '/' + this.appraiser.id
                }).then((res) => {
                    if (data.goback) {
                        router.go(-1)
                    }
                })
            }
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_appraiser')
                inner: 'Edit appraiser'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// AppraiserEditor.vue?2c6f90ce